module.exports = __webpack_public_path__ + "static/media/plantafaucet.7ddc38f6.webp";